import React, { useEffect, useState } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Stack, Typography } from "@mui/material";

import Loading from "./Loading";

const Variability_Grid = ({ variabilityData }) => {
  const [columns, setColumns] = useState(null);
  const [message, setMessage] = useState(null);
  const [tableRows, setTableRows] = useState(null);

  useEffect(() => {
    setColumns(null);
    setTableRows(null);
    setMessage(null);

    if (variabilityData && variabilityData.length > 0) {
      formatData();
    } else {
      setMessage("No data provided...");
      setColumns([]);
    }
  }, [variabilityData]);

  const formatData = () => {
    if (Array.isArray(variabilityData)) {
      for (const record of variabilityData) {
        let columnNames = Object.keys(record.data);
        setColumns((current) => {
          let newNames = [];
          if (Array.isArray(current)) {
            newNames = [...current];
          }
          newNames.push(columnNames);
          return newNames;
        });

        let rowCount = 0;
        let rows = [];

        if (record.data[columnNames[0]].substring(0, 1) === "[") {
          let rowData = record.data[columnNames[0]]
            .replace("[", "")
            .replace("]", "");
          rowCount = rowData.split(",").length;

          let colData = {};
          for (let i = 0; i < rowCount; i++) {
            let colArray = record.data[columnNames[i]]
              .replace("[", "")
              .replace("]", "");
            let colRow = colArray.split(",");
            colData[columnNames[i]] = colRow;
          }

          for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
            let rowData = {};
            for (let colIndex = 0; colIndex < columnNames.length; colIndex++) {
              rowData[columnNames[colIndex]] =
                colData[columnNames[colIndex]][rowIndex];
            }
            rows.push(rowData);
          }
        } else {
          rows.push(record.data);
        }

        setTableRows((current) => {
          let newRows = [];
          if (Array.isArray(current)) {
            newRows = [...current];
          }
          newRows.push(rows);
          return newRows;
        });
      }
    }
  };

  if (!tableRows || !columns) return <Loading />;

  if (message) return <Typography>{message}</Typography>;

  return (
    <Stack
      sx={{ width: "100%", overflow: "auto" }}
      spacing={1}
    >
      {columns.map((colArray, rowIndex) => (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                {colArray.map((column, index) => (
                  <TableCell
                    key={`col_${index}`}
                    sx={{ fontSize: "10px" }}
                  >
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows[rowIndex].map((row, index) => (
                <TableRow key={`row_${index}`}>
                  {colArray.map((column) => (
                    <TableCell sx={{ fontSize: "8px" }}>
                      {row[column]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ))}
    </Stack>
  );
};

export default Variability_Grid;
